var HTMLVideo = require('./HTMLVideo');

module.exports = HTMLVideo;
